import { useLocation } from "react-router-dom";
import Navigation from "../../../components/Navigation";
import BottomAppBar from "../../../components/BottomBar";
import { useSelector } from "react-redux";
const CategoryBrowser = () => {
  const { state } = useLocation();
  const {selectedLanguage} = useSelector(state =>state.Language)

  return (
    <>
      <Navigation
        title={state?.CategoryName || "Subcategory"}
        appBarColor={state?.Color || "orange"}
      />
      <div className="fixed-layout-main flex">
        <iframe
          className="h-full w-full"
          src={state.URL+selectedLanguage}
          title="myFrame"
        ></iframe>
      </div>

      <BottomAppBar />
    </>
  );
};

export default CategoryBrowser;
